import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {MedicalProblemDataService} from './impl/service/ngrx/medicalProblemData.service';
import {MedicalProblemRepository} from './impl/service/ngrx/medicalProblem.repository';
import {
    AI_REALTIME_TOOL_DEFINITIONS,
    AiRealtimeToolDefinition
} from '../../../ai/realtime/api/service/aiRealtime.service';

@NgModule({
    providers: [
        {
            provide: AI_REALTIME_TOOL_DEFINITIONS,
            useValue: [
                {
                    toolName: 'add_problems_antecedent_to_consultation',
                    runningLabel: 'Ajout d\'un problème/antécédent en cours',
                    errorLabel: 'Erreur lors de l’ajout de problèmes/antécédents',
                    successLabel: 'Problème(s)/antécédent(s) ajouté(s)',
                    appEventNames: ['medicalProblem']
                } as AiRealtimeToolDefinition],
            multi: true,
        }
    ]
})
export class MedicalRecordProblemModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                dataService: MedicalProblemDataService,
                service: MedicalProblemRepository,
    ) {

        entityDataService.registerServices({
            MedicalProblem: dataService,
        });

        entityServices.registerEntityCollectionServices({
            MedicalProblem: service,
        });
    }
}
